import React, { Suspense, lazy } from 'react';
const Respond = lazy(() => import('./components/Respond'));

export default function puzzle(props) {
  return (
    <Suspense fallback={<div />}>
      <Respond {...props} />
    </Suspense>
  );
}
